<template>
  <ul>
    <li v-if="errors.incompleteValueError">
      <v-icon color="red">mdi-alert-circle</v-icon>
      <span>
        データ提供側から利用側へ値の受け渡しが必要です。
        マッピングを設定して下さい。
      </span>
    </li>
    <li v-if="errors.needDefaultValueError">
      <v-icon color="red">mdi-alert-circle</v-icon>
      <span>
        データ提供側のデータ項目プロファイルが必須のものではない為、利用側からデータが取得できない可能性があります。
        提供側のデータが存在しない場合に使用する省略値を設定して下さい。
      </span>
    </li>
    <li v-if="errors.differentDataTypesWarn">
      <v-icon color="orange">mdi-alert</v-icon>
      <span>
        データ提供側と利用側で異なるデータ型が指定されています。
        その為、データが正しく変換できない可能性があります。
      </span>
    </li>
    <template v-if="!errors.hasError && !errors.hasWarn">
      <li v-if="!hasLinks">
        <readonly-checkbox></readonly-checkbox>
        <span>
          マッピングが必須ではありません。
        </span>
      </li>
      <li v-if="hasLinks">
        <readonly-checkbox value></readonly-checkbox>
        <span>
          マッピングが設定されています。
        </span>
      </li>
    </template>
  </ul>
</template>

<script>
import ReadonlyCheckbox from "@/components/atoms/ReadonlyCheckbox.vue";
export default {
  name: "ConnectorErrorPanel",
  components: {ReadonlyCheckbox},
  props: {
    errors: {
      type: Object,
      required: true
    },
    hasLinks: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
ul {
  padding: 0;
}

li {
  margin: 10px 0;
  list-style-type: none;
  display: flex;
  align-items: center;
}

span {
  flex-grow: 1;
  vertical-align: middle;
  margin-left: 7px;
  margin-right: 3px;
}
</style>
